export default __webpack_public_path__ + "static/media/redWarning.c8c31799.svg";